<div class="ngx-gallery-thumbnails-wrapper ngx-gallery-thumbnail-size-{{size}}">
  <div class="ngx-gallery-thumbnails" [style.transform]="'translateX(' + thumbnailsLeft + ')'"
    [style.marginLeft]="thumbnailsMarginLeft">
    <div *ngFor="let image of getImages(); let i = index;">
      <a [href]="hasLink(i) ? links[i] : '#'" [target]="linkTarget" class="ngx-gallery-thumbnail"
        [style.width]="getThumbnailWidth()" (click)="handleClick($event, i)" [style.height]="getThumbnailHeight()"
        [style.left]="getThumbnailLeft(i)" [style.top]="getThumbnailTop(i)"
        [ngClass]="{
          'ngx-gallery-active selectedImageBorder': i == selectedIndex,
          'ngx-gallery-clickable': clickable,
          'ngx-gallery-thumbnail-with-border': remainingCount && i < (rows * columns) - 1 && i == selectedIndex
        }"
        [attr.aria-label]="labels[i]">
        <div *ngIf="getFileType(image) == 'image'" [style.background-image]="getSafeUrl(image)"
          class="ngx-gallery-thumbnail"
          [ngClass]="{ 'ngx-gallery-active': i == selectedIndex, 'ngx-gallery-clickable': clickable }"
          style="width: 100% !important; height: 100% !important; position:absolute !important;"></div>
        <div *ngIf="getFileType(image) == 'video'" class="videoWrapperMain">
          <video *ngIf="getFileType(image) == 'video'" class="ngx-gallery-thumbnail ngx-gallery-video-thumb"
            [ngClass]="{ 'ngx-gallery-active selectedVideoBorder': i == selectedIndex, 'ngx-gallery-clickable': clickable }"
            muted playsinline preload="metadata">
            <source [src]="image">
            Your browser does not support the video tag.
          </video>
          <div class="videoPlayThumbnail" aria-hidden="true">
            <i class="material-icons">videocam</i>
          </div>
        </div>
        <div class="ngx-gallery-icons-wrapper">
          <ngx-gallery-action *ngFor="let action of actions" [icon]="action.icon" [disabled]="action.disabled"
            [titleText]="action.titleText" (onClick)="action.onClick($event, i)"></ngx-gallery-action>
        </div>
        <div class="ngx-gallery-remaining-count-overlay"
          *ngIf="remainingCount && remainingCountValue && (i == (rows * columns) - 1)">
          <span class="ngx-gallery-remaining-count">
            <i class="material-icons-outlined">photo_camera</i>
            +{{remainingCountValue}} fotos
          </span>
        </div>
      </a>
    </div>
  </div>
</div>
<ngx-gallery-arrows *ngIf="canShowArrows()" (onPrevClick)="moveLeft()" (onNextClick)="moveRight()"
  [prevDisabled]="!canMoveLeft()" [nextDisabled]="!canMoveRight()" [arrowPrevIcon]="arrowPrevIcon"
  [arrowNextIcon]="arrowNextIcon"></ngx-gallery-arrows>
